// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".FreeformQuestion-cls1__cd9d6beb699cb82af503{/*!*/}.FreeformQuestion-cls2__ac7e720b59ec7bf30180{background:#fff;border:1px solid #dddde2;box-shadow:inset 0px 2px 4px rgba(0,0,0,.04);border-radius:4px;padding:14px 16px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "FreeformQuestion-cls1__cd9d6beb699cb82af503",
	"cls2": "FreeformQuestion-cls2__ac7e720b59ec7bf30180 FreeformQuestion-cls1__cd9d6beb699cb82af503"
};
export default ___CSS_LOADER_EXPORT___;
